import { StyleSheet, css } from 'aphrodite';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { Theme } from '../../config/theme';
import Button from '../Button';
import TextField from '../TextField';

const CLOSE_ICON = require('./close.svg');

class MatchResponseModal extends Component {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.setValue = this.updateTextField.bind(this);
    this.state = {
      message: '',
      charCount: 0,
    };
  }

  getModalTitle() {
    return this.props.actionType === 'decline' ? 'Decline Match Request' : 'Not Now Response';
  }

  getModalDescription() {
    if (this.props.actionType === 'decline') {
      return `Please let ${this.props.borrowerName} know why you're declining their request for ${this.props.dogName}. This helps them understand and potentially improve future requests.`;
    }
    return `Let ${this.props.borrowerName} know why now isn't a good time for sharing ${this.props.dogName}. They may be able to try again in the future.`;
  }

  getPlaceholder() {
    if (this.props.actionType === 'decline') {
      return "Thank you for your interest in my dog. Unfortunately, I don't think this would be a good match because...";
    }
    return "Thank you for your interest. Unfortunately, now isn't a good time because...";
  }

  handleClose() {
    this.setState({
      message: '',
      charCount: 0,
    });
    this.props.onClose();
  }

  handleSubmit(e) {
    e.preventDefault();
    if (!this.state.message.trim()) {
      alert('Please provide a message explaining your decision.');
      return;
    }
    this.props.onSubmit(this.state.message);
    this.handleClose();
  }

  updateTextField(key, value) {
    const charCount = value.length;

    if (charCount <= 500) {
      this.setState({
        message: value,
        charCount,
      });
    }
  }

  render() {
    const modalStyle = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: 9999,
      },
      content: {
        border: 0,
        padding: 0,
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: Theme.white,
        borderRadius: 5,
        width: 580,
        maxWidth: '95%',
      },
    };

    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.handleClose}
        contentLabel={this.getModalTitle()}
        style={modalStyle}
      >
        <div className={css(styles.modal)}>
          <button onClick={this.handleClose} className={css(styles.close)}>
            <img src={CLOSE_ICON} alt="Close" />
          </button>
          <h2 className={css(styles.title)}>{this.getModalTitle()}</h2>
          <p className={css(styles.description)}>{this.getModalDescription()}</p>
          <form onSubmit={this.handleSubmit}>
            <div className={css(styles.input_container)}>
              <TextField
                textArea
                name="message"
                value={this.state.message}
                handler={this.setValue}
                placeholder={this.getPlaceholder()}
                styles={styles.textAreaField}
              />
              <div className={css(styles.char_count)}>{this.state.charCount}/500 characters</div>
            </div>
            <div className={css(styles.buttons)}>
              <Button
                title="Cancel"
                handler={this.handleClose}
                theme="grey"
                styles={styles.cancel_button}
              />
              <Button
                title="Send"
                handler={() => this.handleSubmit(new Event('submit'))}
                theme="blue"
                styles={styles.submit_button}
              />
            </div>
          </form>
        </div>
      </Modal>
    );
  }
}

MatchResponseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  actionType: PropTypes.oneOf(['decline', 'notNow']).isRequired,
  borrowerName: PropTypes.string.isRequired,
  dogName: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  modal: {
    padding: 40,
    position: 'relative',
  },
  close: {
    position: 'absolute',
    top: 20,
    right: 20,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 0,
    outline: 'none',
  },
  title: {
    fontSize: 24,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.primary_color,
    marginBottom: 20,
    paddingRight: 30,
  },
  description: {
    fontSize: 16,
    lineHeight: 1.5,
    color: '#000e1f',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
  },
  input_container: {
    marginBottom: 30,
  },
  textAreaField: {
    display: 'flex',
    flexDirection: 'column',
    height: 150,
    width: '100%',
    marginBottom: 10,

    ':not(.a) > *': {
      flexGrow: 1,
    },
  },
  char_count: {
    textAlign: 'right',
    fontSize: 14,
    color: '#999',
    marginTop: 5,
    fontFamily: Theme.font_family_primary,
  },
  buttons: {
    display: 'flex',
    justifyContent: 'center',
    gap: 15,
  },
  cancel_button: {
    minWidth: 100,
  },
  submit_button: {
    minWidth: 150,
  },
});

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(MatchResponseModal);



// WEBPACK FOOTER //
// ./src/components/MatchResponseModal/index.js